/**
 * Combine a per-bid BBO alert with an existing bid comment into the single
 * annotation string shown in the `BidCell` tooltip (feature 014).
 *
 * Decisions encoded here (spec FR-004/FR-005/FR-006):
 * - Both present  → alert on the first line, comment on the next (`alert\ncomment`).
 * - Alert only    → the alert.
 * - Comment only  → the comment (unchanged from pre-014 behaviour).
 * - Neither       → null (the bid renders with no highlight/tooltip).
 *
 * Empty/whitespace values are treated as absent so a blank alert never produces
 * a highlight (FR-006 "empty alert").
 */
export function combineBidAnnotation(
  alert?: string | null,
  comment?: string | null,
): string | null {
  const a = alert?.trim() ? alert.trim() : null;
  const c = comment?.trim() ? comment.trim() : null;

  if (a && c) return `${a}\n${c}`;
  return a ?? c ?? null;
}
